/* index.tsx generated by @compiled/babel-plugin v0.36.1 */
import "./index.compiled.css";
import { ax, ix } from "@compiled/react/runtime";
import React from 'react';
import { ProductStoreHeader } from './product-store-header';
import { useViewStateContext } from '../context';
import { DrawerCloseButton } from '@atlaskit/drawer/compiled';
import { Box } from '@atlaskit/primitives/compiled';
import CrossIcon from '@atlaskit/icon/core/migration/close--cross';
var styles = {
  box: "_kqswstnw _154i1b66 _hb4eutpp _sf6putpp"
};
export var BaseHeader = function BaseHeader() {
  return /*#__PURE__*/React.createElement(Box, {
    xcss: styles.box
  }, /*#__PURE__*/React.createElement(DrawerCloseButton, {
    icon: CrossIcon,
    testId: "drawer-close-button"
  }));
};
export var CrossFlowSupportHeader = function CrossFlowSupportHeader() {
  var _useViewStateContext = useViewStateContext(),
    state = _useViewStateContext.state;
  if (state.sourceContext === 'more' && state.targetProduct !== 'loom') {
    return /*#__PURE__*/React.createElement(ProductStoreHeader, null);
  }
  return /*#__PURE__*/React.createElement(BaseHeader, null);
};